<template>
  <div class="wrap">
    <div class="login">
      <div>
        <div class="title">theCella</div>
        <div class="subtitle">ADMIN & CMS</div>

        <div class="content">
          아이디
          <br />
          <input
            v-model="userID"
            type="text"
            placeholder="아이디를 입력해주세요."
            @keyup.enter="login"
          />
        </div>

        <div class="content">
          비밀번호
          <br />
          <input
            v-model="password"
            type="password"
            placeholder="비밀번호를 입력해주세요."
            autocomplete="on"
            @keyup.enter="login"
          />
        </div>

        <div class="content">
          <br />
          <button class="btn" @click="login">로그인</button>
        </div>

        <div class="footer">
          <div>powered & provided by tricubics</div>
          <img src="/static/img/ico-logo.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */

import Configuration from '@/js/Configuration';

export default {
  data: () => ({
    userID: '',
    password: '',
    access: '',
    refresh: '',
  }),
  methods: {
    async login() {
      if (this.userID === '') {
        alert('아이디를 입력해 주세요.');
        return;
      }
      if (this.password === '') {
        alert('비밀번호를 입력해 주세요.');
        return;
      }

      try {
        const encPass = this.$jsEncrypt.encrypt(this.password);
        const res = await this.$http.put(
          `${Configuration.value(
            'CACCOUNT_ADDRESS',
          )}/api/v1/caccount/user/login`,
          {
            userID: this.userID,
            passwd: encPass,
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        /*
        const payload = this.$jwtDecode(res.data.accessToken);
        if (payload.role === 3) {
          this.$cookie.set('accessToken', res.data.accessToken);
          this.$cookie.set('refreshToken', res.data.refreshToken);

          this.$router.push({
            name: 'Home',
          });
          return;
        }

        throw new Error(`Account role is "${payload.role}"`);
        */
        this.$cookie.set('accessToken', res.data.accessToken);
        this.$cookie.set('refreshToken', res.data.refreshToken);

        const token = this.$jwtDecode(this.$cookie.get('accessToken'));

        // admin이 아닐 경우 부서ID 및 회사ID를 조회하여 저장
        if (token.role !== 1) {
          let companyID = null;
          let companyName = null;
          let divisionID = null;
          let divisionName = null;

          try {
            const getURL = `${Configuration.value(
              'CACCOUNT_ADDRESS',
            )}/api/v1/caccount/user/${token.uID}`;

            const result = await this.$http.get(getURL, {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              },
            });
            if (result.status !== 200) {
              throw new Error(`Response status is "${result.status}"`);
            }
            if (result.data.resultCode !== '0000') {
              throw new Error(`ResultCode is "${result.data.resultCode}"`);
            }

            if (result.data.user.role === 2) { // manager
              companyID = result.data.user.manager.companyID;
              companyName = result.data.user.manager.companyName;
              divisionID = result.data.user.manager.divisionID;
              divisionName = result.data.user.manager.divisionName;
            } else if (result.data.user.role === 3) { // operator
              companyID = result.data.user.operator.companyID;
              companyName = result.data.user.operator.companyName;
              divisionID = result.data.user.operator.divisionID;
              divisionName = result.data.user.operator.divisionName;
            } else if (result.data.user.role === 4) { // monitor
              companyID = result.data.user.monitor.companyID;
              companyName = result.data.user.monitor.companyName;
              divisionID = result.data.user.monitor.divisionID;
              divisionName = result.data.user.monitor.divisionName;
            }

            this.$store.commit('setCompanyID', companyID);
            this.$store.commit('setCompanyName', companyName);
            this.$store.commit('setDivisionID', divisionID);
            this.$store.commit('setDivisionName', divisionName);
          } catch (e) {
            console.error(e);
          }
        } else {
          this.$store.commit('setCompanyID', null);
          this.$store.commit('setCompanyName', null);
          this.$store.commit('setDivisionID', null);
          this.$store.commit('setDivisionName', null);
        }

        this.$router.push({
          name: 'Home',
        });
      } catch (e) {
        if (e.response) {
          if (e.response.status === 404) {
            alert(
              '아이디, 또는 비밀번호가 잘못 되었습니다. 다시 한 번 확인해주세요.',
            );
            return;
          }
        }

        alert('로그인에 실패하였습니다.\n잠시 후에 다시 시도해 주세요.');
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.login {
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
.login .title {
  width: 480px;
  text-align: center;
  font-size: 128px;
  font-weight: 200;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: -4px;
  color: #0058ee;
}
.login .subtitle {
  margin-bottom: 52px;
  width: 480px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #cbddfb;
}
.login .content {
  margin-bottom: 26px;
  width: 480px;
  font-size: 14.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: 0.19px;
  color: #212121;
}
.login .content input {
  margin-top: 12px;
  padding: 16px;
  width: 100%;
  height: 56px;
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
  border: solid 0.5px #686868;
}
.login .content input::placeholder {
  color: rgba(72, 72, 72, 0.64);
}
.login .content .btn {
  width: 480px;
  height: 56px;
  background-color: #0058ee;
  font-size: 14.8px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  transition: 0.2s;
}
.login .content .btn:hover {
  background-color: #0068fe;
}
.login .footer {
  margin-top: 80px;
  width: 480px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.15px;
  text-align: center;
  color: #bbbdbf;
}
.login .footer img {
  margin: 12px;
  width: 27px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue